import React from 'react';
import {
  AnxietyIcon,
  StressIcon,
  CrisisIcon,
  TraumaIcon,
  SelfEsteemIcon,
  IdentityIcon,
  LGTBIIcon,
} from '../illustrations/ServiceIcons';
import KnotDecoration from '../illustrations/KnotDecoration';

const services = [
  {
    id: 1,
    title: 'Ansiedad y crisis de angustia',
    description: 'Cuando la mente va demasiado rápido y el cuerpo vive en alerta. El objetivo no es "eliminar" la ansiedad a la fuerza, sino aprender a relacionarte con ella de otra manera, recuperar seguridad y ampliar tu sensación de control en el día a día.',
    Icon: AnxietyIcon,
  },
  {
    id: 2,
    title: 'Estrés, rumiación y bloqueo emocional',
    description: 'Acompañamos procesos de estrés crónico, sobrecarga, hiperexigencia, rumiación, dificultad para concentrarte o tomar decisiones, y bloqueo emocional. Trabajamos para que puedas recuperar claridad, descanso y una forma más amable de sostenerte.',
    Icon: StressIcon,
  },
  {
    id: 3,
    title: 'Crisis vitales',
    description: 'Acompañamos duelos, rupturas, cambios de trabajo, mudanzas, crisis existenciales o etapas de incertidumbre. La terapia puede ayudarte a transitar el dolor sin quedarte atrapada en él, y a reconstruir sentido cuando parece que nada encaja.',
    Icon: CrisisIcon,
  },
  {
    id: 4,
    title: 'Trauma y experiencias difíciles',
    description: 'Hay vivencias que dejan huella: abuso, violencia, acoso, negligencia o situaciones que te superaron. En terapia trabajamos desde un enfoque seguro y respetuoso, para que puedas integrar lo vivido sin revivirlo, recuperar calma y sentirte más libre en el presente.',
    Icon: TraumaIcon,
  },
  {
    id: 5,
    title: 'Autoestima, límites y relaciones',
    description: 'Acompañamos dificultades con la inseguridad, la necesidad de aprobación, dependencia emocional, dificultad para poner límites y patrones repetidos en vínculos. El objetivo es fortalecer una autoestima real y construir relaciones más sanas y coherentes contigo.',
    Icon: SelfEsteemIcon,
  },
  {
    id: 6,
    title: 'Procesos de identidad',
    description: 'Acompañamos procesos de autoconocimiento, construcción de identidad, transición a la vida adulta, cambios vitales y búsqueda de dirección. Trabajamos para que puedas habitarte con más claridad, menos miedo y más autenticidad.',
    Icon: IdentityIcon,
  },
  {
    id: 7,
    title: 'Acompañamiento afirmativo LGTBIQA+',
    description: 'Un espacio terapéutico afirmativo y seguro donde tu identidad y tu orientación no se cuestionan ni se tratan como un problema. Aquí no tienes que explicarte ni justificarte: puedes venir tal y como eres.',
    Icon: LGTBIIcon,
  },
  {
    id: 8,
    title: 'Estrés académico y laboral',
    description: 'Burnout, presión constante, dificultad para desconectar y sensación de no llegar a todo. Trabajamos para que puedas recuperar el equilibrio, establecer límites saludables y mejorar tu relación con el rendimiento.',
    Icon: StressIcon,
  },
  {
    id: 9,
    title: 'Gestión emocional y regulación',
    description: 'Herramientas para manejar emociones intensas como la ira, la frustración o la tristeza desbordante. Aprendemos juntos a entender tus emociones y a responder de forma más flexible y compasiva.',
    Icon: SelfEsteemIcon,
  },
];

export default function Services() {
  return (
    <section id="servicios" className="section-padding bg-blush">
      <div className="container-narrow">
        <div className="text-center mb-16">
          <h2 className="mb-4">Nuestros servicios</h2>
          <p className="text-[var(--color-inerva-text-light)] max-w-2xl mx-auto">
            Cada persona es única. Por eso, adaptamos nuestra intervención a tus necesidades específicas,
            ofreciéndote un acompañamiento personalizado.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <article key={service.id} className="card-service group">
              <div className="mb-5">
                <service.Icon className="w-14 h-14 transition-transform duration-300 group-hover:scale-110" />
              </div>
              <h3 className="text-xl mb-3 font-serif">{service.title}</h3>
              <p className="text-[var(--color-inerva-text-light)] text-sm leading-relaxed">
                {service.description}
              </p>
            </article>
          ))}
        </div>

        <div className="mt-10 bg-forest rounded-[var(--radius-xl)] p-10 text-center">
          <KnotDecoration size="sm" invert className="mx-auto mb-4 opacity-60" />
          <h3 className="text-xl mb-3 font-serif text-cream">Cada historia es única</h3>
          <p className="text-cream-80 text-sm mb-6 max-w-lg mx-auto">
            Si no encuentras tu situación aquí, escríbenos. Encontraremos la mejor manera de acompañarte.
          </p>
          <a href="#contacto" className="btn-primary text-lg px-10 py-4 bg-cream text-forest hover:bg-white">
            Escríbenos
          </a>
          <p className="text-cream-50 text-xs mt-4">Sin compromiso. Te respondemos en menos de 24h.</p>
        </div>
      </div>
    </section>
  );
}
